var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8764 7.18221C59.0249 7.18221 57.4342 7.18221 55.5828 7.18221C55.5828 4.8975 55.5828 2.28471 55.5828 0C53.8466 0.868149 42.966 6.30837 41.2185 7.18221C40.9997 7.18221 18.7849 7.18221 18.5276 7.18221C14.879 7.18221 11.9106 10.1505 11.9106 13.7992V15.1226H48.9658C54.8035 15.1226 59.553 19.872 59.553 25.7098V48.8692H60.8764C64.5248 48.8692 67.4933 45.901 67.4933 42.2522C67.4933 40.6728 67.4933 15.3787 67.4933 13.7992C67.4933 10.1507 64.5251 7.18221 60.8764 7.18221Z",
    fill: "#434854"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9657 19.0928C47.7748 19.0928 7.81294 19.0928 6.61699 19.0928C2.96851 19.0928 0 22.0609 0 25.7098V38.9437C0 38.9437 0 51.4431 0 52.1777C0 55.8262 2.96812 58.7947 6.61699 58.7947H11.9106V65.9769C12.3338 65.7653 25.8522 59.006 26.2749 58.7947H48.9657C52.6142 58.7947 55.5827 55.8266 55.5827 52.1777C55.5827 50.7009 55.5827 27.1851 55.5827 25.7098C55.5827 22.0613 52.6146 19.0928 48.9657 19.0928ZM7.94038 29.0183H27.7913V32.9884C26.451 32.9884 9.28085 32.9884 7.94038 32.9884C7.94038 31.5999 7.94038 30.4068 7.94038 29.0183ZM47.6423 48.8692C45.6628 48.8692 9.92098 48.8692 7.94038 48.8692C7.94038 47.4807 7.94038 46.2875 7.94038 44.899H47.6423V48.8692ZM47.6423 40.9288C45.6628 40.9288 9.92098 40.9288 7.94038 40.9288C7.94038 39.5403 7.94038 38.3471 7.94038 36.9586H47.6423V40.9288Z",
    fill: "#434854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChat);
export default __webpack_public_path__ + "static/media/empty-chat.e727d38606842ead4f861b2deddb2a04.svg";
export { ForwardRef as ReactComponent };